import i18n from "@/i18n";
import { SettingsVue } from "fs-pb-vue2/vueModels/settings/SettingsVue";

export class SettingsVueGB extends SettingsVue {
  
  /**Закрытие формыы */
  async destroyForm(): Promise<void> {
    this.$emit("hideSelf");
  }

  async callAction(action: () => Promise<void>) {
    await action();
  }

  /** контент диалогового окна */
  dialogContent: any = {};

  dialogTransfer: boolean =  false;
  
  dialogLoginSettings: boolean =  false;

  get actionsLogin(): Array<any> {
    const actionsLogin: Array<any> = [];
      actionsLogin.push({
        /** Смена пароля */
        text: i18n.t("main.settings.changePassword"),
        iconClass: "login-settings-icon",
        action: () => {
          this.dialogContent = new Object({
            vueName: "PasswordEditModal",
          });
          this.dialogLoginSettings = true;
        }
      });
    return actionsLogin;
  }

  get actions(): Array<any> {
    const actions: Array<any> = [];
    if(this.apiData.OperationCodeOfSetSbpDefaultBank) {
      actions.push({
        /** Установка банка в сбп по умолчанию */
        text: i18n.t("main.settings.sbpDefault"),
        iconClass: "sbp-icon",
        action: () => {
          this.dialogContent = new Object({
            vueName: "SbpDefaultModal",
          });
          this.dialogTransfer = true;
        }
      });
    }
    if(this.apiData &&
      this.apiData.OperationCodeOfSetSbpMe2MeAcceptedBanks) {
      actions.push({
        /** Запрос на перевод из других банков */
        text: i18n.t("main.settings.sbpBanks"),
        iconClass: "sbp-icon",
        action: () => {
          this.dialogContent = new Object({
            vueName: "BankSelectModal",
          });
          this.dialogTransfer = true;
        }
      });
    }
    if(this.apiData.OperationCodeOfSetSbpEnable) {
      actions.push({
        /** Разрешения сбп */
        text: i18n.t("main.settings.sbpEnable"),
        iconClass: "sbp-icon",
        action: () => {
          this.dialogContent = new Object({
            vueName: "SbpEnableModal",
          });
          this.dialogTransfer = true;
        }
      });
    }

    // actions.push({
    //   /**Действие оплаты со счета */
    //   text: i18n.t("main.settings.editAlias"),
    //   iconClass: "edit-login-icon",
    //   action: () => {
    //     this.openDialog(this.operationsList.aliasEdit);
    //   }
    // });
    // actions.push({
    //   /**Действие оплаты со счета */
    //   text: i18n.t("main.settings.logout"),
    //   iconClass: "logout-icon",
    //   action: async () => {
    //     await this.logout();
    //   }
    // });
    return actions;
  }

  setShowHiddenItems() {
    this.configStore.setItemsVisibility(this.showHiddenItems);
  }

  setShowClosedItems() {
    this.configStore.setClosedItemsVisibility(this.showClosedItems);
  }
}
